<template>
  <div class="training-plan trainplan">
    <div
      v-if="notMaster"
      class="d-flex position-absolute opacity_2"
      style="gap: 0.5rem"
    >
      <div
        class="gw_btn clr-error"
        @click="allOpen = !allOpen"
      >
        --toggle open all--
      </div>
      <div
        class="gw_btn clr-error"
        @click="clearFinishOnAll"
      >
        --clear finish all--
      </div>
      <div
        class="gw_btn clr-error"
        @click="finishAllButFirstOne"
      >
        --finish all but one--
      </div>
      <div
        class="gw_btn clr-error"
        @click="clearPlanIntroVideo"
      >
        --clear intro video--
      </div>
    </div>
    <DashboardArticle
      :item="item"
      componentTag="div"
      class="dasarttcsl_reversed dasarttcsl_readonly mt-12 trainplan_header"
      style="
        --height: auto;
        --clr-back: transparent;
        --title-font-size: 2rem;
        --line-clamp: 55;
        --description-font-size: 1rem;
        overflow: unset;
        --title-overflow: unset;
        --text-overflow: unset;
        --left-overflow: unset;
      "
    >
      <template #left>
        <component
          :is="item.thumbnail_svg"
          class="w-100 trainplan_svg"
        />
      </template>

      <template #description="v">
        <div class="sttdplans_spantext">
          <span v-html="v.item.description_on_open || v.item.description"></span>
          <div
            v-if="v.item.note"
            class="text-medium weight_400 mt-4 text-italic"
            v-html="v.item.note"
          ></div>
        </div>
      </template>
      <template #before_tags>
        <div
          v-for="tag in item.types || []"
          :key="tag.id"
          class="gw_tag gw_tag_ll my-auto"
          :style="`
              position:relative;
              --tag-top: 0;
              --tag-right: 0;
              --tag-padding:0.325rem 0.5rem 0.325rem 0.85rem;
              --clr-tag-back: var(--clr-black-0);
              `"
        >
          {{ tag.name }}
        </div>
      </template>
      <template #under_description>
        <div
          v-if="item.video_id"
          class="gw_btn-v1 mt-4 mr-auto"
          @click="playIntroVideo"
        >
          <div class="mdi mdi-play-circle text-semi-large mr-2"></div>
          {{ $t('btn.intro') }}
        </div>
      </template>
      <template #after_tags> </template>
    </DashboardArticle>

    <div
      class="d-flex f-wrap"
      style="gap: 1rem"
    >
      <div
        class="d-flex f-wrap w-100"
        style="gap: 1rem"
      >
        <div class="flex-1">
          <div
            class="text-medium clr-grey text-nowrap"
            style="margin-bottom: 0.25em; --num-fnt-weight: 700; --num-padding: 0 0 0 0.25rem"
            v-html="
              $t('study_plans.steps_x_y', {
                x: planFinishedSteps.length,
                y: item.steps.length,
              })
            "
          ></div>
          <ProgressLine
            class="prgsline_no-animate"
            :style="`
             box-shadow: var(--menu-shadow);
              --end: ${finishedPercent * 100}%;
              --radius: 4px;
              --radius-progress: 4px;
              --height: calc(1.875rem + 4px);
              --clr-line: var(--clr-plan-primary);
              --clr-back: linear-gradient(to right, var(--clr-black-1-3), var(--clr-black-1));
              --clr-line: linear-gradient(to right, #00ad8d, #008970);
              `"
          />
        </div>
        <div
          class="d-flex mr-auto mt-auto"
          style="gap: 0.5rem"
        >
          <CheckboxRow
            class="vidfitr_checkbox-rows"
            :item="vid_formats"
            style="--cherow-shadow: var(--menu-shadow); --clr-row-back: var(--clr-black-1-2)"
            :checkboxAs="'btn'"
            :isSingle="true"
            @update="handleUpdate"
          >
            <template #default="v">
              {{ $t(`study_plans.${v.id}`) }}
            </template>
          </CheckboxRow>
        </div>
      </div>
    </div>

    <div class="trainplan_tasks mt-4">
      <StudyPlanStep
        v-for="item in steps"
        :key="item.id"
        :item="item"
        :opened="notMaster && allOpen"
        class="trainplan_tasks_item"
        :finished="planFinishedSteps.includes(item.index)"
        :notMaster="notMaster"
        @toggle:finished="toggleFinished(item.index)"
      ></StudyPlanStep>
    </div>

    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="party"
        class="trainplan_party"
      >
        <!-- <TrainerStreakPrompt :streak="{ moves: 10, showPrompt: true }" /> -->
        <AnimConfetti style="--cff-height: var(--party-height)" />

        <ExpandCard
          :opened="partyOpen"
          :hasCloseIcon="false"
          class="trainplan_party_card f-column"
          style="
            z-index: 2;
            background: var(--clr-black-1);
            --clr-icon: var(--clr-plan-primary);
            --max-height: 16rem;
            --min-height: 6rem;
            --radius: 8px;
            --icon-opener-padding: 0.5rem;
            --content-padding: 1.5rem 1.5rem 2rem 1.5rem;
            --radius-conent: 0 0 8px 8px;
            --transition: 0.9s;
            --closed-opacity: 1;
            box-shadow: 0 0 0px 2px var(--clr-plan-primary);
            width: clamp(1rem, 44rem, calc(100vw - 2rem));
          "
        >
          <!-- icon="mdi-balloon" -->
          <template #title>
            <div
              class="text-big weight_600 f-center text-center w-100"
              style="color: var(--clr-plan-primary)"
            >
              <!-- <div class="mdi mdi-balloon text-big mr-3"></div> -->
              {{ $t('study_plans.congratulations') }}
            </div>
          </template>
          <div
            class="weight_600 clr-white f-center text-center w-100 f-column"
            style="
              font-size: clamp(1rem, 2.25rem, 5vw);
              --fnt-size: clamp(1rem, 1.75rem, 5vw);
              gap: 0.75rem;
            "
            v-html="$t('study_plans.you_have_finished', { name: item.title })"
          ></div>
        </ExpandCard>

        <div class="anim-slide-fade-in-timed trainplan_pog trainplan_pog1">
          <Pog />
        </div>
        <div
          class="anim-slide-fade-in-timed trainplan_pog trainplan_pog2"
          style="--slide-in-x: -2rem"
        >
          <Pog />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import CheckboxRow from '@/components/Forms/CheckboxRow'
import DashboardArticle from '@/components/Dashboard/DashboardArticle'
import StudyPlanStep from '@/components/StudyPlans/StudyPlanStep'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import { toggleArr } from '@/helpers/helpers'
import prompt_mix from '@/mixins/prompt_mix'
import ProgressLine from '@/components/lib/ProgressLine'
import AnimConfetti from '@/components/animations/AnimConfetti'
import Pog from '@/assets/pog.svg'
// import TrainerStreakPrompt from '@/components/Trainer/TrainerStreakPrompt'

export default {
  name: 'StudyPlan',
  components: {
    DashboardArticle,
    StudyPlanStep,
    ProgressLine,
    AnimConfetti,
    Pog,
    ExpandCard,
    CheckboxRow,
  },
  mixins: [float_mix, prompt_mix, format_mix],
  props: {
    item: {
      default: () => {},
    },
  },
  data() {
    return {
      show: '',
      allOpen: false,
      party: false,
      partyOpen: false,
      // party: true,
      // partyOpen: true,
    }
  },
  created() {
    document.title = `${this.item.title} - GTO Wizard`
    if (!this.item.video_id) return
    try {
      const vids = JSON.parse(localStorage.getItem('training_plans_videos_opened') || '[]')
      const { video_id } = this.item
      if (video_id && !vids.includes(this.item.video_id)) {
        localStorage.setItem('training_plans_videos_opened', [...vids, video_id])
        this.playIntroVideo()
      }
    } catch (error) {
      //
    }
  },
  methods: {
    playIntroVideo() {
      this.$store.dispatch('router_set_dialogs', `yt-dialog_videoid-${this.item.video_id}`)
    },
    handleUpdate(item) {
      this.show = item.selected[0]
    },
    toggleFinished(idx) {
      const plans = this.$store.getters.finishedStudyPlans

      const steps = toggleArr({ arr: this.planFinishedSteps, item: idx })

      if (this.planFinishedSteps.length < steps.length) {
        if (steps.length === this.item.steps.length) {
          this.party = true
          setTimeout(() => {
            this.partyOpen = true
          }, 800)
          setTimeout(() => {
            this.partyOpen = false
          }, 2800)
          setTimeout(() => {
            this.partyOpen = false
            this.party = false
          }, 3600)
        } else {
          this.pr_dispatchMessage({ id: 'training_plan_step_finished' })
        }
      }

      plans[this.item.id] = {
        ...(plans[this.item.id] || {}),
        steps,
      }
      this.updateSettings(plans)
    },
    finishAllButFirstOne() {
      const plans = this.$store.getters.finishedStudyPlans
      const steps = this.item.steps.map((i, idx) => idx)
      steps.shift()
      plans[this.item.id] = {
        ...(plans[this.item.id] || {}),
        steps,
      }
      this.updateSettings(plans)
    },
    clearFinishOnAll() {
      const plans = this.$store.getters.finishedStudyPlans
      plans[this.item.id] = {
        ...(plans[this.item.id] || {}),
        steps: [],
      }
      this.updateSettings(plans)
    },
    updateSettings(patchData) {
      this.$store.dispatch('setSettingsValue', { key: 'finishedStudyPlans', patchData })
    },
    clearPlanIntroVideo() {
      localStorage.setItem('training_plans_videos_opened', [])
    },
  },
  computed: {
    notMaster() {
      return import.meta.env.VITE_BRANCH !== 'master'
    },
    vid_formats() {
      const options = ['completed', 'incompleted']
      const disabled = [
        !this.planFinishedSteps.length ? 'completed' : null,
        this.planFinishedSteps.length === this.item.steps.length ? 'incompleted' : null,
      ].filter(i => i)
      const selected = [this.show]
      const res = {
        id: 'steps',
        title: this.$t('common.steps'),
        options,
        disabled,
        selected,
      }
      return res
    },
    showOptions() {
      return [
        {
          value: 'all',
          text: this.$t('study_plans.show_all'),
          disabled: false,
        },
        {
          value: 'completed',
          text: this.$t('study_plans.show_completed'),
          disabled: !this.planFinishedSteps.length,
        },
        {
          value: 'incompleted',
          text: this.$t('study_plans.show_incompleted'),
          disabled: this.planFinishedSteps.length === this.item.steps.length,
        },
      ]
    },
    steps() {
      let res = this.item.steps.map((step, index) => ({
        ...step,
        index,
      }))
      // console.log(res)
      if (this.show === 'completed') {
        res = res.filter(step => this.planFinishedSteps.includes(step.index))
      } else if (this.show === 'incompleted') {
        res = res.filter(step => !this.planFinishedSteps.includes(step.index))
      }
      // console.log(res)
      return res
    },
    finishedPercent() {
      return this.planFinishedSteps.length / this.item.steps.length
    },
    planFinishedSteps() {
      const plans = this.$store.getters.finishedStudyPlans
      const plan = plans[this.item.id] || {}
      const steps = plan?.steps || []
      // console.log(steps)
      return steps
    },
  },
}
</script>
<style lang="scss" scoped>
.trainplan {
  --clr-plan-primary: var(--clr-primary);
  // --clr-plan-primary: var(--clr-yellow);
  // --clr-plan-primary: var(--clr-blue);
  // --clr-plan-primary: var(--clr-husng-back);
  &_tasks {
    display: flex;
    flex-wrap: wrap;
    // flex-direction: column;
    // display: grid;
    // grid-template-columns: repeat(3, 1fr);
    gap: 1rem;

    &_item {
      min-width: 100%;
      max-width: 100%;
      box-shadow: var(--menu-shadow);
      // width: clamp(12rem, calc((100% / 4) - calc(3rem / 4)), 100vw);
      // width: clamp(12rem, calc((100% / 3) - calc(2rem / 3)), 100vw);
      // width: clamp(12rem, calc((100% / 2) - calc(1rem / 2)), 100vw);
      // width: clamp(12rem, calc((100% / 2) - 0.5rem), 100vw);
      // flex: 0;
      // max-width: clamp(12rem,minmax(12);
    }
  }
  &_svg {
    transform: scale(1.2);
  }
  &_party {
    z-index: 99;
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background: var(--clr-black-0);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    --party-height: 100vh;

    --anim-duration: 1s;
    --slide-in-x: 1rem;
    animation: slideFadeIn var(--anim-duration);
    &_card {
      animation: partyScale 1s ease-in-out;
      @keyframes partyScale {
        0% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.2);
        }
        100% {
          transform: scale(1);
        }
      }
    }

    &_text {
      overflow: hidden;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      flex-direction: column;
      z-index: 10;
      font-size: 4rem;
      // height: var(--p;
      width: var(--party-height);
      // border: solid 1px var(--clr-black-2);
      color: var(--clr-primary);
      border: solid 1px var(--clr-primary);
      padding: 3rem;
      // padding: 0rem 1rem 2rem 1rem;
      border-radius: 1rem;
      // border-radius: 50%;
      background: var(--clr-black-0-1);
      &_sub {
        font-size: 1.5rem;
        margin-top: 1rem;
      }
      // background: radial-gradient(var(--clr-black-0) 25%, transparent 60%);
    }
  }
}

.trainplan_pog {
  z-index: 1;
  position: fixed;
  filter: brightness(66%);
  height: clamp(24rem, 45.5rem, 50vw);
  svg {
    width: 100%;
    height: 100%;
  }
}
.trainplan_pog1 {
  left: 64%;
}
.trainplan_pog2 {
  right: 64%;
  top: 10%;
  svg {
    transform: scaleX(-1);
  }
}

@media (max-width: 620px) {
  // .trainplan_party{}
  .trainplan {
    &_header {
      padding: 0 0.5rem;
    }
    &_svg {
      transform: scale(2);
      margin-bottom: 6rem;
    }
  }
  .trainplan_pog {
    height: clamp(12rem, 45.5rem, 60vw);
    filter: brightness(88%);
  }
  .trainplan_pog1 {
    right: -18%;
    left: unset;
    top: 1rem;
  }
  .trainplan_pog2 {
    display: none;
  }
}

@keyframes slideFadeIn {
  0% {
    transform: translate(-50%, -55%);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}

@media (max-width: 770px) {
  .sttdplans_spantext {
    background: rgba(18, 18, 18, 0.95);
    border-radius: 4px;
    padding: 0.75rem;
  }
}
</style>
